<div class="header_search header_search_mobile">
  <div class="title-page">Equipe de Planejamento do Projeto</div>
  <div class="content_search">
    <div class="new-project" *ngIf="permissoes?.canCreateEquipe">
      <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo</a>
    </div>
  </div>
</div>
<div class="system-table table-container" *ngIf="permissoes?.canSeeEquipe">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nome</th>
          <th>Responsabilidades</th>
          <th>Organização</th>
          <th>Departamento</th>
          <th>Email</th>
          <th>Telefone</th>
          <th class="text-center width5">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of equipeList;">
          <td class="title">{{ item.id }}</td>
          <td><span class="title-span">{{ item?.name }}</span></td>
          <td>{{ item.equip_role_names }}</td>
          <td>{{ item.organization }}</td>
          <td>{{ item.department }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.fone }}</td>
          <td>
            <div class="btn-icon">
              <a class="icon-table" [routerLink]="editar(item?.id)">
                <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
              </a>
            </div>
          </td>
        </tr>
        <tr *ngIf="!equipeList?.length" class="border-b-radius">
          <td colspan="8" class="text-center">Nenhum Registro Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="hr-line-dashed"></div>
  <app-capacidade-execucao-edit *ngIf="loadCadastro" [projeto]="projeto" [equipeReadyList]="equipeReadyList" [permissoes]="permissoes"></app-capacidade-execucao-edit>
</div>

<app-loading [loader]="isLoading"></app-loading>